module.exports = __webpack_public_path__ + "img/text3bg.b5d6c46d.png";